export default __webpack_public_path__ + "static/media/Natours.478e4b19.png";